export type Website = {
  slug: string;
  title: string;
  category: string;
  summary: string;
  url: string;
  thumbnail?: string;
  tags: string[];
  year: number;
  highlights?: string[];
};

export const websites: Website[] = [
  {
    slug: 'pharmavision',
    title: 'PharmaVision',
    category: 'SaaS Marketing Site',
    summary:
      'Marketing site for the PharmaVision enterprise sales force automation platform — product features, dashboards, testimonials, and demo requests.',
    url: 'https://www.pharmavision.io/',
    thumbnail: '/websites/pharmavision.jpg',
    tags: ['React', 'Tailwind', 'SEO'],
    year: 2025,
    highlights: [
      'Product, features, and results communicated for an enterprise pharma buyer',
      'Demo request flow integrated with the product backend',
      'Fast, accessible, structured-data-friendly',
    ],
  },
  {
    slug: 'nomad-partners-bg',
    title: 'Nomad Partners',
    category: 'Recruitment Agency',
    summary:
      'Marketing site for an international recruitment agency placing candidates with 500+ companies across 20+ countries.',
    url: 'https://www.nomadpartners.bg/en',
    thumbnail: '/websites/nomad-partners-bg.jpg',
    tags: ['React', 'Laravel', 'Multilingual', 'SEO'],
    year: 2024,
    highlights: [
      'Multilingual content (EN / BG)',
      'Service pages tuned for the recruitment buyer journey',
      'Connects to the Nomad recruitment platform on the backend',
    ],
  },
  {
    slug: 'nomad-jobs-mk',
    title: 'NomadJobs.mk',
    category: 'Recruitment Agency',
    summary:
      'Macedonian marketing site for the Nomad recruitment family — candidate-facing job exploration and employer service pages.',
    url: 'https://nomadjobs.mk/mk',
    thumbnail: '/websites/nomad-jobs-mk.jpg',
    tags: ['React', 'Laravel', 'Multilingual', 'SEO'],
    year: 2024,
  },
  {
    slug: 'nomad-care-bg',
    title: 'Nomad Care',
    category: 'Services Marketing Site',
    summary:
      'Marketing site for a Bulgarian professional cleaning company — homes, offices, and industrial cleaning with online inquiry.',
    url: 'https://www.nomadcare.bg/',
    thumbnail: '/websites/nomad-care-bg.jpg',
    tags: ['React', 'Laravel', 'SEO'],
    year: 2024,
  },
  {
    slug: 'globalnet-adv',
    title: 'Global Net ADV',
    category: 'Marketing Agency Site',
    summary:
      'Brand and services site for a North Macedonian marketing and advertising agency — capabilities, portfolio, and client-facing inquiry.',
    url: 'https://globalnetadv.mk/',
    thumbnail: '/websites/globalnet-adv.jpg',
    tags: ['React', 'Laravel', 'SEO'],
    year: 2024,
  },
  {
    slug: 'gna-healthcare',
    title: 'GNA Healthcare',
    category: 'Healthcare Marketing Site',
    summary:
      'Healthcare-focused marketing site — services, expertise, and patient/partner inquiry, designed to communicate trust at first impression.',
    url: 'https://gnahealthcare.mk/',
    thumbnail: '/websites/gna-healthcare.jpg',
    tags: ['React', 'Laravel', 'SEO'],
    year: 2024,
  },
  {
    slug: 'gna-eshop',
    title: 'GNA E-shop',
    category: 'E-commerce · In development',
    summary:
      'Upcoming online store for a medical association — product catalog, ordering, and member-aware purchasing built around the association\'s real workflow.',
    url: 'http://gnaeshop.mk/',
    thumbnail: '/websites/gna-eshop.jpg',
    tags: ['E-commerce', 'PHP', 'Laravel', 'React', 'MySQL'],
    year: 2026,
    highlights: [
      'E-commerce for a medical association (zdruzhenie na lekari)',
      'Catalog, cart, checkout, and member-tier ordering',
      'In active development',
    ],
  },
  {
    slug: 'nexsol-labs',
    title: 'Nexsol Labs',
    category: 'Studio Site',
    summary:
      'The site you\'re on. A custom software studio site with 3D scenes, full project case studies, and an end-to-end services breakdown.',
    url: 'https://nexsollabs.com/',
    thumbnail: '/websites/nexsol-labs.jpg',
    tags: ['React', 'TypeScript', 'Tailwind', 'Three.js', 'Framer Motion'],
    year: 2026,
    highlights: [
      'Three lazy-loaded 3D scenes built with @react-three/fiber + drei',
      'Per-project case study pages with rich SEO',
      'Designed and engineered end to end',
    ],
  },
];
